import classNames from "classnames";
import "./kg-table.css";
import PropTypes from "prop-types";
import { Fragment, useMemo } from "react";

KgTable.propTypes = {
    columns: PropTypes.array,
    data: PropTypes.array
}

const align = {
    left: "text-start",
    center: "text-center",
    right: "text-end",
    top: "align-top",
    middle: "align-middle",
    bottom: "align-bottom"
}

export default function KgTable({ columns = [], data = [], customFooter }) {

    const tColumns = useMemo(() => columns, [columns]);
    const tData = useMemo(() => data, [data]);

    const CreateHeaderRow = ({ config }) => {
        return (
            <tr>
                {config.map(col => (
                    <th className={classNames("kg-bg-green text-white text-nowrap", col.align && align[col.align])} key={col.key}>{col.labelRender ? col.labelRender() : col.label}</th>
                ))}
            </tr>
        )
    }

    const CreateRow = ({ config, row, rowIndex }) => {
        return (
            <tr>
                {config.map((col, colIndex) => (
                    <td key={col.key + colIndex} className={classNames("kg-dark-gray kg-bg-sky fs-7 border", col.align && align[col.align], col.vAlign && align[col.vAlign])}>
                        {col.key === 'sequence' ? rowIndex + 1 : col.render ? col.render(row,rowIndex) : row[col.key]}
                    </td>))
                }
            </tr>
        );
    }

    return (
        <div className="table-responsive">
            <table className="table mb-0">
                <thead>
                    <CreateHeaderRow config={tColumns} />
                </thead>
                <tbody className="kg-bg-sky">
                    {tData.length === 0 && <tr><td className="kg-bg-sky kg-dark-gray text-center py-3 border" colSpan={tColumns.length}>No Record Found</td></tr>}
                    {tData.map((row, rowIndex) => <Fragment key={rowIndex}><CreateRow config={tColumns} row={row} key={rowIndex} rowIndex={rowIndex} /></Fragment>)}
                </tbody>
                {(tData.length !== 0 && customFooter) && customFooter()}
            </table>
        </div>
    );
}

export function KgTableFooter({ children }) {
    return (
        <tfoot>
            {children}
        </tfoot>
    )
}